import axiosInstance from "../../../../../axiosInstance";
import {
  info,
  success,
  error,
} from "../../../../../store/notification/actions";

export async function addCatalogCurrent(store_id, supplier_id) {
  try {
    info("Saving...");
    const result = await axiosInstance.post(
      "/physicalInventory/addCatalogCurrent",
      {
        store_id,
        supplier_id,
      }
    );
    success(result.data.data.records_submitted + " items saved");
    return { data: result.data.data, success: true };
  } catch (err) {
    error(err.response.data.message || err.message);
    return { error: err.message, success: false };
  }
}
